export const CONTACT = {
  PHONE: "+5493518119701",
  EMAIL: "tercerespacio.cultura@gmail.com",
  ADRESS: "Humberto Primo 836 - Córdoba, Argentina",
  ALIAS: "TERCER.ESPACIO",
};

export const SOCIAL_MEDIA = {
  INSTAGRAM: "https://www.instagram.com/tercerespacio.cultura/",
  WHATSAPP_DEFAULT:
    "https://wa.me/+5493518119701?text=Hola%20Tercer%20Espacio!%20Me%20gustar%C3%ADa%20consultarles%20por%20",
  WHATSAPP_NEW_PAGE:
    "https://wa.me/+5493518119701?text=Hola%20Tercer%20Espacio!%20Me%20gustar%C3%ADa%20crear%20una%20p%C3%A1gina%20para%20mi%20espacio%20de%20teatro.",
};
